// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.afq-title {
  margin: 0px 0 24px 0;
  font-size: 20px;
  color: #2d2d2f;
  letter-spacing: 0.2px;
}

.afq-row {
  margin-bottom: 12px;
}

.afq-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}

.afq-primary-btn {
  border-radius: 10px;
  padding: 11px 18px;
  box-shadow: 0 8px 18px rgba(94, 27, 255, 0.22);
}

.afq-primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

.afq-cancel-btn {
  border-radius: 10px;
  padding: 11px 18px;
}

.faq-editor .ql-container {
  min-height: 220px;
}

.faq-editor .ql-editor {
  min-height: 200px;
  cursor: text;
}

.faq-editor-click-capture {
  cursor: text;
}
`, "",{"version":3,"sources":["webpack://./src/components/addFaqModal.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".afq-title {\r\n  margin: 0px 0 24px 0;\r\n  font-size: 20px;\r\n  color: #2d2d2f;\r\n  letter-spacing: 0.2px;\r\n}\r\n\r\n.afq-row {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.afq-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  margin-top: 22px;\r\n}\r\n\r\n.afq-primary-btn {\r\n  border-radius: 10px;\r\n  padding: 11px 18px;\r\n  box-shadow: 0 8px 18px rgba(94, 27, 255, 0.22);\r\n}\r\n\r\n.afq-primary-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  box-shadow: none;\r\n}\r\n\r\n.afq-cancel-btn {\r\n  border-radius: 10px;\r\n  padding: 11px 18px;\r\n}\r\n\r\n.faq-editor .ql-container {\r\n  min-height: 220px;\r\n}\r\n\r\n.faq-editor .ql-editor {\r\n  min-height: 200px;\r\n  cursor: text;\r\n}\r\n\r\n.faq-editor-click-capture {\r\n  cursor: text;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
